import { appVariant, config } from '../config';
import { getSeoForVariant } from './helpers';
import { updateMetadata } from '../utils/metadata';

/** Apply translated SEO strings while keeping static assets (images, keywords) from config. */
export function applyLocaleSeo(): void {
  const translated = getSeoForVariant(appVariant);
  updateMetadata({
    ...config.seo,
    title: translated.title,
    description: translated.description,
    ogTitle: translated.ogTitle,
    ogDescription: translated.ogDescription,
    twitterTitle: translated.twitterTitle,
    twitterDescription: translated.twitterDescription,
  });
}
